"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { AuthContext } from "@/components/auth/Auth";
import { useWaveDropsLeaderboard, WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { WaveLeaderboardDrop } from "./WaveLeaderboardDrop";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { WaveLeaderboardEmptyState } from "./WaveLeaderboardEmptyState";
import { WaveLeaderboardLoading } from "./WaveLeaderboardLoading";
import { WaveLeaderboardLoadingBar } from "./WaveLeaderboardLoadingBar";
interface WaveLeaderboardDropsProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onCreateDrop: () => void;
}
export const WaveLeaderboardDrops: React.FC<WaveLeaderboardDropsProps> = t0 => {
  const $ = _c(32);
  const {
    wave,
    sort,
    onCreateDrop
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    connectedProfile
  } = useContext(AuthContext);
  const t1 = connectedProfile?.handle ?? null;
  let t2;
  if ($[0] !== sort || $[1] !== t1 || $[2] !== wave.id) {
    t2 = {
      waveId: wave.id,
      connectedProfileHandle: t1,
      sort
    };
    $[0] = sort;
    $[1] = t1;
    $[2] = wave.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t2);
  let t3;
  if ($[4] !== fetchNextPage || $[5] !== hasNextPage || $[6] !== isFetching || $[7] !== isFetchingNextPage) {
    t3 = () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[4] = fetchNextPage;
    $[5] = hasNextPage;
    $[6] = isFetching;
    $[7] = isFetchingNextPage;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const intersectionElementRef = useIntersectionObserver(t3);
  let t4;
  if ($[9] !== pathname || $[10] !== router || $[11] !== searchParams) {
    t4 = drop => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("drop", drop.id);
      router.push(`${pathname}?${params.toString()}`);
    };
    $[9] = pathname;
    $[10] = router;
    $[11] = searchParams;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const onDropClick = t4;
  if (isFetching && drops.length === 0) {
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <WaveLeaderboardLoading />;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  if (drops.length === 0) {
    let t5;
    if ($[14] !== onCreateDrop || $[15] !== wave) {
      t5 = <WaveLeaderboardEmptyState onCreateDrop={onCreateDrop} wave={wave} />;
      $[14] = onCreateDrop;
      $[15] = wave;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    return t5;
  }
  let t5;
  if ($[17] !== drops || $[18] !== onDropClick || $[19] !== wave) {
    let t6;
    if ($[21] !== onDropClick || $[22] !== wave) {
      t6 = drop_0 => <WaveLeaderboardDrop key={drop_0.id} drop={drop_0} wave={wave} onDropClick={onDropClick} />;
      $[21] = onDropClick;
      $[22] = wave;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    t5 = drops.map(t6);
    $[17] = drops;
    $[18] = onDropClick;
    $[19] = wave;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[24] !== isFetchingNextPage) {
    t6 = isFetchingNextPage && <WaveLeaderboardLoadingBar />;
    $[24] = isFetchingNextPage;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== intersectionElementRef) {
    t7 = <div ref={intersectionElementRef} />;
    $[26] = intersectionElementRef;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t5 || $[29] !== t6 || $[30] !== t7) {
    t8 = <div className="tw-space-y-4">{t5}{t6}{t7}</div>;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
};